import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import './ReferralOptions.scss';
import { postRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import copyTextToClipboard from '../../../clipboardUtils';
import grayLogo from '../../../../assets/images/Logo_Gray.svg';
import spinner from '../../../../assets/images/spinner-DNA-2s-200px.svg';

// From http://emailregex.com/

var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var employerTweet = "I'm using @MeetClora to find high-fit consultants to match my on-demand needs. Find out how:";
var consultantTweet = "I'm using @Clora, a technology platform that matches my expertise to exciting life science companies that I otherwise don't have access to. Find out how:";
var ReferralOptions = /*#__PURE__*/function (_Component) {
  function ReferralOptions(props) {
    var _this;
    _classCallCheck(this, ReferralOptions);
    _this = _callSuper(this, ReferralOptions, [props]);
    _this.state = {
      emails: [],
      submitting: false,
      successMessage: '',
      errorMessage: '',
      existingUsersMessage: '',
      invalidEmail: false,
      tag: '',
      submittingLinkedinPost: false,
      linkedinPost: '',
      linkedinError: props.authStatus === 401 ? 'Something has gone wrong. Please try again later.' : null,
      actionBlock: props.returnFromLinkedIn ? 'linkedIn' : null,
      copyFailed: false
    };
    _this.changeActionBlock = _this.changeActionBlock.bind(_this);
    _this.changeLinkedinPost = _this.changeLinkedinPost.bind(_this);
    _this.submitEmails = _this.submitEmails.bind(_this);
    _this.submitLinkedinPost = _this.submitLinkedinPost.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
    _this.onValidationReject = _this.onValidationReject.bind(_this);
    _this.handleCopyReferralLink = _this.handleCopyReferralLink.bind(_this);
    return _this;
  }
  _inherits(ReferralOptions, _Component);
  return _createClass(ReferralOptions, [{
    key: "onValidationReject",
    value: function onValidationReject(values) {
      if (values && values.length && values[0].trim() !== '') {
        this.setState({
          invalidEmail: true
        });
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(emails) {
      this.setState({
        emails: emails,
        invalidEmail: false
      });
    }
  }, {
    key: "handleEmailChange",
    value: function handleEmailChange(input) {
      if (input === ' ' || input === ';' || input === ',') {
        return;
      }
      this.setState({
        tag: input
      });
    }
  }, {
    key: "submitEmails",
    value: function submitEmails() {
      var _this2 = this;
      var emails = this.state.emails;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        newReferralPath = _this$props.newReferralPath,
        location = _this$props.location,
        referredUserType = _this$props.referredUserType;
      if (!emails.length) {
        return;
      }
      this.setState({
        submitting: true
      });
      postRequest(newReferralPath, {
        emails: emails,
        referred_user_type: referredUserType
      }, csrfToken).then(function (_ref) {
        var _ref$data = _ref.data,
          valid = _ref$data.valid,
          invalid = _ref$data.invalid,
          ignored = _ref$data.already_member;
        var errEmails = invalid.map(function (referral) {
          return referral.email;
        });
        var errorMsg = '';
        if (invalid.length) {
          errorMsg = "You've already shared a referral link with ".concat(errEmails.join(', '), ".");
        }
        var successMsg = '';
        if (valid.length) {
          var plural = valid.length !== 1 ? 's' : '';
          var list = valid.map(function (referral) {
            return referral.email;
          }).join(', ');
          successMsg = "Email".concat(plural, " sent! Recipient").concat(plural, ": ").concat(list);
        }
        var existingUsersMsg = '';
        if (ignored.length) {
          var ignoredEmails = ignored.map(function (referral) {
            return referral.email;
          }).join(', ');
          existingUsersMsg = "These referrals are already Clora members: ".concat(ignoredEmails);
        }
        _this2.setState({
          errorMessage: errorMsg,
          successMessage: successMsg,
          existingUsersMessage: existingUsersMsg,
          emails: errEmails,
          submitting: false
        });
        _this2.props.addReferrals(valid);
        analyticsTrack('Clicked on Send invite emails', {
          location: location,
          referred_user_type: referredUserType
        });
      })["catch"](function () {
        _this2.setState({
          errorMessage: 'Something has gone wrong. Please try again later',
          successMessage: '',
          submitting: false
        });
      });
    }
  }, {
    key: "submitLinkedinPost",
    value: function submitLinkedinPost() {
      var _this3 = this;
      var linkedinPost = this.state.linkedinPost;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        shareOnLinkedinUrl = _this$props2.shareOnLinkedinUrl;
      this.setState({
        submittingLinkedinPost: true
      });
      postRequest(shareOnLinkedinUrl, {
        share_commentary: linkedinPost
      }, csrfToken).then(function () {
        _this3.setState({
          submittingLinkedinPost: false,
          sharedOnLinkedin: true,
          linkedinError: null
        });
        analyticsTrack('Clicked on Share On LinkedIn', {
          location: location
        });
      })["catch"](function () {
        _this3.setState({
          submittingLinkedinPost: false,
          linkedinError: 'Something has gone wrong. Please try again later.',
          sharedOnLinkedin: false
        });
      });
    }
  }, {
    key: "changeActionBlock",
    value: function changeActionBlock(actionType) {
      var _this4 = this;
      return function () {
        return _this4.setState({
          actionBlock: actionType
        });
      };
    }
  }, {
    key: "changeLinkedinPost",
    value: function changeLinkedinPost(event) {
      this.setState({
        linkedinPost: event.target.value
      });
    }
  }, {
    key: "handleCopyReferralLink",
    value: function () {
      var _handleCopyReferralLink = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var referralPath, success;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              referralPath = this.props.referralPath;
              _context.next = 3;
              return copyTextToClipboard(referralPath);
            case 3:
              success = _context.sent;
              this.setState({
                actionBlock: 'copy',
                copyFailed: !success
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCopyReferralLink() {
        return _handleCopyReferralLink.apply(this, arguments);
      }
      return handleCopyReferralLink;
    }()
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props3 = this.props,
        heroCopy = _this$props3.heroCopy,
        isConsultant = _this$props3.isConsultant,
        referredUserType = _this$props3.referredUserType;
      if (heroCopy) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
          className: "mt-3 mb-4"
        }, heroCopy), /*#__PURE__*/React.createElement("div", {
          className: "body-text-1 mb-4"
        }, referredUserType === 'consultant' ? 'Refer consultants and get $500 when they match to a project!' : 'Would you like to help friends or colleagues also find talent faster?'));
      }
      if (isConsultant && referredUserType === 'consultant') {
        return /*#__PURE__*/React.createElement("h1", {
          className: "mt-3 mb-4"
        }, /*#__PURE__*/React.createElement("span", {
          className: "green-highlight"
        }, "Invite Consultants"), ' ', "and earn $500 when they are hired for their first project!");
      }
      if (isConsultant && referredUserType === 'employer') {
        return /*#__PURE__*/React.createElement("h1", {
          className: "mt-3 mb-4"
        }, /*#__PURE__*/React.createElement("span", {
          className: "purple-highlight"
        }, "Invite Employers"), ' ', "and earn $500 when they hire their first consultant!");
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
        className: "mt-3 mb-2"
      }, "Accelerate the life science industry."), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 mb-4"
      }, "Refer employers and get $500 when their projects match a consultant!"));
    }
  }, {
    key: "renderActionBlock",
    value: function renderActionBlock() {
      var _this$props4 = this.props,
        referralPath = _this$props4.referralPath,
        referredUserType = _this$props4.referredUserType,
        location = _this$props4.location,
        authCodeUrl = _this$props4.authCodeUrl;
      var _this$state = this.state,
        actionBlock = _this$state.actionBlock,
        submittingLinkedinPost = _this$state.submittingLinkedinPost,
        sharedOnLinkedin = _this$state.sharedOnLinkedin,
        linkedinError = _this$state.linkedinError,
        copyFailed = _this$state.copyFailed;
      if (actionBlock === 'copy') {
        analyticsTrack('Clicked on Copy referral link', {
          location: location
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "input-group copy-link mt-2",
          id: "".concat(referredUserType === 'consultant' ? 'consultant' : 'employer', "-copy-referral-link")
        }, /*#__PURE__*/React.createElement("input", {
          className: "form-control fs-hide",
          type: "text",
          value: referralPath.replace(/https?:\/\//, ''),
          readOnly: true
        }), /*#__PURE__*/React.createElement("span", {
          className: "input-group-addon"
        }, copyFailed ? 'Copy failed, please try again' : 'Copied!'));
      }
      if (actionBlock === 'linkedIn') {
        analyticsTrack('Clicked on Post It to LinkedIn', {
          location: location
        });
        if (submittingLinkedinPost) {
          return /*#__PURE__*/React.createElement("div", {
            className: "mt-3 text-center"
          }, /*#__PURE__*/React.createElement("hr", {
            className: "mt-0 mb-1"
          }), /*#__PURE__*/React.createElement("img", {
            src: spinner,
            alt: ""
          }), /*#__PURE__*/React.createElement("a", {
            role: "button",
            href: "# ",
            className: "btn linkedin-btn full-width-btn",
            disabled: true
          }, "Sharing..."));
        }
        if (sharedOnLinkedin) {
          return /*#__PURE__*/React.createElement("div", {
            className: "mt-4 text-center text-primary"
          }, "Shared!");
        }
        if (authCodeUrl) {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("hr", {
            className: "mt-3 mb-2"
          }), /*#__PURE__*/React.createElement("a", {
            role: "button",
            tabIndex: 0,
            href: authCodeUrl,
            onClick: function onClick() {
              return analyticsTrack('Clicked on Connect to LinkedIn', {
                location: location
              });
            },
            className: "btn linkedin-btn full-width-btn ".concat(referredUserType === 'consultant' ? 'consultant' : 'employer', "-connect-to-linkedin")
          }, "Connect to LinkedIn"), linkedinError && /*#__PURE__*/React.createElement("div", {
            className: "text-danger mt-5"
          }, linkedinError));
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "mt-3"
        }, /*#__PURE__*/React.createElement("hr", {
          className: "mt-0 mb-2"
        }), /*#__PURE__*/React.createElement("div", {
          className: "mb-5"
        }, /*#__PURE__*/React.createElement("textarea", {
          name: "share_commentary",
          className: "form-control",
          placeholder: "Add a personal message to the post...",
          onChange: this.changeLinkedinPost
        })), /*#__PURE__*/React.createElement("div", {
          className: "mb-2 grey-border small-text px-3 py-3 line-height-20"
        }, /*#__PURE__*/React.createElement("strong", null, referredUserType === 'consultant' ? 'Find your next opportunity in days not weeks' : 'Find your next consultant in days not weeks'), /*#__PURE__*/React.createElement("div", {
          className: "mt-2"
        }, referralPath), /*#__PURE__*/React.createElement("div", {
          className: "mt-2"
        }, "Life Science marketplace to match biotech companies with on-demand expertise.")), /*#__PURE__*/React.createElement("a", {
          role: "button",
          href: "# ",
          className: "btn linkedin-btn full-width-btn ".concat(referredUserType === 'consultant' ? 'consultant' : 'employer', "-share-on-linkedin"),
          onClick: this.submitLinkedinPost
        }, "Share on LinkedIn"), linkedinError && /*#__PURE__*/React.createElement("div", {
          className: "text-danger mt-5"
        }, linkedinError));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        referralPath = _this$props5.referralPath,
        referredUserType = _this$props5.referredUserType,
        location = _this$props5.location,
        showSocialMediaShareButtons = _this$props5.showSocialMediaShareButtons,
        isConsultant = _this$props5.isConsultant;
      var _this$state2 = this.state,
        errorMessage = _this$state2.errorMessage,
        successMessage = _this$state2.successMessage,
        existingUsersMessage = _this$state2.existingUsersMessage,
        emails = _this$state2.emails,
        invalidEmail = _this$state2.invalidEmail,
        tag = _this$state2.tag;
      var addKeys = [9, 13, 32, 186, 188]; // tab, enter, non-printing space, semi-colon, comma

      var tweet = referredUserType === 'consultant' ? consultantTweet : employerTweet;
      var tweetText = encodeURIComponent(tweet);
      var tweetHashtags = encodeURIComponent('Clora');
      var tweetUrl = encodeURIComponent(referralPath);
      return /*#__PURE__*/React.createElement("div", {
        className: "invite-modal-body style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        src: grayLogo,
        alt: "Clora Logo",
        height: "40",
        width: "93"
      })), this.renderTitle()), /*#__PURE__*/React.createElement("div", {
        className: "body"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "email-addresses",
        className: "mt-0 body-text-2 medium emails-label mb-2"
      }, /*#__PURE__*/React.createElement("strong", null, "Send my referral link by email:"))), /*#__PURE__*/React.createElement("div", {
        className: "form-inline flex"
      }, /*#__PURE__*/React.createElement(TagsInput, {
        value: emails,
        onChange: this.handleInputChange,
        onChangeInput: this.handleEmailChange,
        className: "form-control email-addresses fs-hide",
        addKeys: addKeys,
        inputProps: {
          placeholder: emails.length === 0 ? 'Enter email addresses...' : '',
          className: emails.length !== 0 && tag === '' ? 'react-tagsinput-input no-width' : ' react-tagsinput-input'
        },
        inputValue: tag,
        addOnBlur: true,
        validationRegex: emailRegex,
        onValidationReject: this.onValidationReject
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.submitEmails,
        className: "".concat(isConsultant ? 'consultant' : 'employer', "-submit-emails btn btn-primary d-flex gap-2 align-items-center ").concat(this.state.submitting && 'disabled', " ").concat(isConsultant && 'is-consultant')
      }, /*#__PURE__*/React.createElement("span", {
        className: "d-none d-md-block"
      }, "Send "), "Invite")), invalidEmail && /*#__PURE__*/React.createElement("div", {
        className: "text-danger mt-5"
      }, "Please enter a valid email address."), successMessage && /*#__PURE__*/React.createElement("div", {
        className: "text-primary mt-5"
      }, successMessage), errorMessage && /*#__PURE__*/React.createElement("div", {
        className: "text-danger mt-5"
      }, errorMessage), existingUsersMessage && /*#__PURE__*/React.createElement("div", {
        className: "mt-5"
      }, existingUsersMessage), showSocialMediaShareButtons && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always g-column--centered small-text action-separator"
      }, /*#__PURE__*/React.createElement("span", {
        className: "grey-separator"
      }), /*#__PURE__*/React.createElement("span", {
        className: "pr-10 ps-3"
      }, "or"), /*#__PURE__*/React.createElement("span", {
        className: "grey-separator"
      })), /*#__PURE__*/React.createElement("div", {
        className: "action-buttons d-flex flex-column flex-md-row gap-3 justify-content-between"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.handleCopyReferralLink,
        className: "btn btn-primary"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-link"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ps-3"
      }, "Copy it")), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.changeActionBlock('linkedIn'),
        className: "btn linkedin-btn ".concat(referredUserType === 'consultant' ? 'consultant' : 'employer', "-post-it")
      }, /*#__PURE__*/React.createElement("i", {
        className: "fab fa-linkedin-in"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ps-3"
      }, "Post it")), /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "twitter-share-btn btn ".concat(referredUserType === 'consultant' ? 'consultant' : 'employer', "-tweet-it"),
        href: "https://twitter.com/intent/tweet?text=".concat(tweetText, "&url=").concat(tweetUrl, "&hashtags=").concat(tweetHashtags),
        onClick: function onClick() {
          return analyticsTrack('Clicked on Tweet It to Twitter', {
            location: location
          });
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fab fa-twitter"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ps-3"
      }, "Tweet it"))), this.renderActionBlock())));
    }
  }]);
}(Component);
ReferralOptions.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  addReferrals: PropTypes.func,
  returnFromLinkedIn: PropTypes.bool,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  authStatus: PropTypes.number,
  referredUserType: PropTypes.string.isRequired,
  heroCopy: PropTypes.string,
  location: PropTypes.string.isRequired,
  isConsultant: PropTypes.bool,
  showSocialMediaShareButtons: PropTypes.bool
};
ReferralOptions.defaultProps = {
  returnFromLinkedIn: false,
  authCodeUrl: null,
  authStatus: null,
  addReferrals: function addReferrals() {
    return null;
  },
  isConsultant: true,
  showSocialMediaShareButtons: true,
  heroCopy: null
};
export default ReferralOptions;